export default __webpack_public_path__ + "static/media/my.645d2fbf.svg";